import { combineReducers } from 'redux';

import roundPlayReducer from './reducers/roundPlayReducer';
import screenReducer from './reducers/screenReducer';
import gameDetailsReducer from './reducers/gameDetailsReducer';
import hoverTargetStateReducer from './reducers/hoverTargetStateReducer';
import draggabilityReducer from './reducers/draggabilityReducer';

const reducers = combineReducers({
  roundPlay: roundPlayReducer,
  screen: screenReducer,
  gameDetails: gameDetailsReducer,
  hoverTargetStates: hoverTargetStateReducer,
  draggability: draggabilityReducer,
});

export default reducers;
